import { Control, Controller } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { WorkflowTriggersSelect } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowPopupBock/WorkflowTriggersSelect/WorkflowTriggersSelect';
import type { WorkflowFormValues } from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';

export const WorkflowTriggersBlock = ({
  control,
  isCustom = true,
}: {
  control: Control<WorkflowFormValues>;
  isCustom?: boolean;
}) => {
  return (
    <div className={'flex flex-col gap-1.5'}>
      <div>
        <p className={'text-sm text-ebony_opacity_80 font-semibold'}>Trigger</p>
      </div>
      {isCustom && (
        <div>
          <WorkflowTriggersSelect control={control} />
        </div>
      )}
      {isCustom && (
        <div>
          <Controller
            control={control}
            name="trigger_value"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Input
                type={'textarea'}
                className={
                  '!px-3.5 !py-3 input valid border-l-0 border-r-0 border-t-0 !rounded-none'
                }
                textareaRows={1}
                placeholder={'Type value'}
                invalidMessage={error?.message}
                value={value}
                isValid={!error?.message}
                onChange={onChange}
              />
            )}
          />
        </div>
      )}
      {!isCustom && (
        <Input
          type={'text'}
          className={'!px-3.5 !py-3 read-only:!bg-[#a498ff1a]'}
          value={'When AI lacks the knowledge to assist a customer.'}
          readonly={true}
          isValid={true}
        />
      )}
    </div>
  );
};
